'use client';

import { useTranslations } from 'next-intl';
import { FeatureDetailContent } from './FeatureDetailContent';
import {
    Ticket,
    Shield,
    Lock,
    CreditCard,
    Clock,
    Globe
} from 'lucide-react';

export function EVoucherContent() {
    const t = useTranslations('eVoucher');

    const features = [
        {
            icon: Ticket,
            title: t('features.step1.title'),
            description: t('features.step1.description'),
        },
        {
            icon: Shield,
            title: t('features.step2.title'),
            description: t('features.step2.description'),
        },
        {
            icon: Lock,
            title: t('features.step3.title'),
            description: t('features.step3.description'),
        },
        {
            icon: CreditCard,
            title: t('features.step4.title'),
            description: t('features.step4.description'),
        },
        {
            icon: Clock,
            title: t('features.step5.title'),
            description: t('features.step5.description'),
        },
        {
            icon: Globe,
            title: t('features.step6.title'),
            description: t('features.step6.description'),
        },
    ];

    // Get benefits list from translations, ensuring it's always an array
    const benefitsRaw = t.raw('benefits.list');
    const benefits = Array.isArray(benefitsRaw) ? benefitsRaw : (benefitsRaw ? [benefitsRaw] : []);

    return (
        <FeatureDetailContent
            pageKey="e-voucher"
            translationNamespace="eVoucher"
            features={features}
            benefits={benefits}
            ctaIcon={Ticket}
            showWhatIsBitcoin={false}
            introImageSrc="/images/features/e-voucher.webp"
            introImageAlt={t('intro.imageAlt') || 'E-Voucher in MLM Software'}
            introParagraphKeys={['paragraph2', 'paragraph3']}
            introSectionHeadingPage="e-voucher"
            introSectionHeadingTitle={t('intro.sectionHeadingTitle') || 'About E-Voucher'}
            introSectionHeadingPill={t('intro.sectionHeadingPill') || 'E-Voucher'}
            useLocaleContent={true}
        />
    );
}

